import React, { useEffect, useRef, useState, useContext } from 'react'
import { GlobalContext } from "../Globalstate";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from 'react-router-dom';
import Nav from '../Components/Nav';
import Sidebar from '../Components/Sidebar';
import Swal from 'sweetalert2'
import { f, database, storage, auth } from "../config";
import db from "../config";
import firebase from 'firebase';
import emailjs from "emailjs-com";


function DepositComplete() {
  const [selectedplan, setselectedplan] = useState("")
  const [Selectedinvestment, setSelectedinvestment] = useState({})
  //get the plan id from url parameters


  useEffect(() => {
    // Get the value of a specific parameter
    var params = new URLSearchParams(window.location.search);
    var paramValue = params.get("plan");
    setselectedplan(paramValue)
    console.log(paramValue); // Output: The value of the parameter

    let selectedinvestment = investments.find(o => o.id === paramValue);
    console.log(selectedinvestment)
    setSelectedinvestment(selectedinvestment)
  }, [])


  const investments = [
    {
      id: "1",
      name: "SILVER PLAN",
      minimum: "100",
      Maximum: "1000",
      profits: "4",
      duration: "7"
    },
    {
      id: "2",
      name: "GOLD PLAN ",
      minimum: "1000",
      Maximum: "9999",
      profits: "6",
      duration: "7"
    },
    {
      id: "3",
      name: "Diamond PLAN",
      minimum: "10000",
      Maximum: "29999",
      profits: "8",
      duration: "14"
    },
    {
      id: "4",
      name: "Platinum PLAN",
      minimum: "30000",
      Maximum: "49999",
      profits: "10",
      duration: "30"
    },
    {
      id: "5",
      name: "Zenith PLAN",
      minimum: "50000",
      Maximum: "50000000000",
      profits: "15",
      duration: "31"
    }
  ]


  const history = useNavigate();
  const [{ userdetails, loggedin, tradingpair }, dispatch] = useContext(GlobalContext);
  const [stage2, setstage2] = useState(false)

  const [Amount, setAmount] = useState(0)
  const [loading, setloading] = useState(true)
  const [Coins, setCoins] = useState([]);

  const [image, setimage] = useState(null);
  const [url, seturl] = useState("");
  const [progress, setprogress] = useState(0);
  const [imagepresnt, setimagepresent] = useState(false);
  const [prevfile, setprevFile] = useState("")

  const [CoinInfo, setCoinInfo] = useState("")
  const CoinsList = [
    {
      id: "1",
      name: "BITCOIN",
      address: "bc1qp9nufyrwkaxyvpgk4uuhq6gxsrfh2rq6ugxeej"
    },
    {
      id: "2",
      name: "ETHEREUM",
      address: "0xF353a55a74375dc152aCFf399854D98686E3ddb6"
    },
    {
      id: "3",
      name: "USDT",
      address: "TRuf3ZFAJ39kC16ZcMMp47DbU9cXr494qh"
    },
  ]
  const SetCoinInfo = (value) => {
    let selectedcoin = CoinsList.find(o => o.id === value);
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: `You Selected ${selectedcoin.name} as Payment Method`,
      showConfirmButton: false,
      timer: 1500
    })
    setCoinInfo(selectedcoin)
  }

  const copyAlert = () => {
    navigator.clipboard.writeText(CoinInfo.address);
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: `${CoinInfo.name} Address Was Copied Please Proceed To Payment`,
      showConfirmButton: false,
      timer: 1500
    })
  }


  const handleUpload = () => {

    if(Amount!=0 && CoinInfo!=""){
      updatehistory(url);
    }else{
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'please fill in the required fields!',
        footer: '<a href="">Why do I have this issue?</a>'
    })
    }
   
  };

  const sendAdminMaiil = async () => {

    var templateParams = {
      to_name: userdetails.fullname,
      message:
        ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
           mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
           font-size: 14px;">You have initiated a Deposit Request on your account. The status of this transaction is <strong>PENDING</strong>.Upon
           Confirmation from Our System your account will be credited with $${Amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} worth of ${CoinInfo.name}
          </div>`,

      user_email: userdetails.email,
      notification: "Deposit"
    };

    // setloading(false)
    //handleClick1()

    await emailjs
      .send(
        "service_7z7wtie",
        "template_nkt2bb2",
        templateParams,
        "9J9xbrUTOKeMOCJHy"
      )
      .then(
        function (response) {
          // setloading(false)
        },
        function (err) {
          // setloading(false)
          alert("FAILED...", err);
        }
      );
  }

  const CreatUserObj = async (obj) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    let uobj = {
      fullname: userdetails.fullname,
      email: userdetails.email,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      userid: userids,
      info: obj

    };

    const userdetail1 = await db
      .collection("deposits")
      .add(uobj)
      .then(function () {
        console.log("Document successfully written!");
        Swal.fire(
          'Succesful Transaction!',
          'Your Investment will been activated.',
          'success'
      )
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };
  const updatehistory = async (urls) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    const increment = firebase.firestore.FieldValue.increment(parseInt(Amount));
    CreatUserObj({
      image: urls,
      date: Date.now(),
      amt: Amount,
      mode: "Deposit",
      coin: CoinInfo.name,
      investmentplan:selectedplan
    })
    var washingtonRef = db.collection("users").doc(userids);
    await washingtonRef.update({
      // Totaldeposit: increment,
      Deposithistory: firebase.firestore.FieldValue.arrayUnion({
        image: urls,
        date: Date.now(),
        amt: Amount,
        mode: "Deposit",
        coin: CoinInfo.name,
        investmentplan:selectedplan
      }),
    });
  };




  useEffect(() => {
    if (loggedin) {
      console.log(userdetails);
      console.log(userdetails.email);
      setloading(false)
    } else {
      f.auth().onAuthStateChanged(function (user) {
        if (user) {
          var userid = f.auth().currentUser;
          var userids = userid.uid;
          fetchuserdata(userids);
          setloggedin(true);
        } else {
          setloggedin(false);
          setloading(false)
          history("/");
        }
      });
    }

    let myDate = new Date();
    console.log(myDate.getTime())
    console.log(addHoursToDate(myDate, 1).getTime())
    console.log(myDate)
    console.log(addHoursToDate(myDate, 1))

  }, []);

  function addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(date.getHours() + hours));
  }

  const fetchuserdata = async (userid) => {
    var docRef = db.collection("users").doc(userid);
    const fetching = await docRef
      .onSnapshot((function (doc) {
        if (doc.exists) {
          setdetails(doc.data());
          console.log(doc.data())
          setloading(false)
        } else {
          console.log("No such document!");
        }
      })
      )

  };

  const setdetails = (data) => {
    dispatch({ type: "setuserdetails", snippet: data });
  };

  const setloggedin = (data) => {
    dispatch({ type: "setloggedin", snippet: data });
  };



  return (
    <div>
      {/* Required meta tags */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {/* Bootstrap CSS */}
      <link rel="stylesheet" href="/font-awesome/css/all.css" />
      <link rel="stylesheet" href="/font-awesome/css/all.min.css" />
      <link rel="stylesheet" href="/font-awesome/css/fontawesome.min.css" />
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossOrigin="anonymous" />
      <link rel="stylesheet" href="/css/sidebar.css" />
      <link rel="stylesheet" href="/css/deposit.css" />
      <link rel="stylesheet" href="/preloader/preloader.css" />
      <title>oceanic-invest</title>

      <input type="hidden" name="_token" defaultValue="8wLGfkXGrQ6qNUYfR7MWftAFCeHYyO1yW5PEYiHq" />
      {/* <div className="preloader position-fixed start-0 top-0 bottom-0 end-0 min-vh-100">
          <div className="loader">
            <svg viewBox="0 0 120 120" className="loaderSvg" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <circle className="load one" cx={60} cy={60} r={40} />
              <circle className="load two" cx={60} cy={60} r={40} />
              <circle className="load three" cx={60} cy={60} r={40} />
              <g>
                <circle className="point one" cx={45} cy={70} r={5} />
                <circle className="point two" cx={60} cy={70} r={5} />
                <circle className="point three" cx={75} cy={70} r={5} />
              </g>
            </svg>
          </div>
        </div>     */}
      <div id="goog-gt-tt" className="VIpgJd-yAWNEb-L7lbkb skiptranslate" style={{ borderRadius: '12px', margin: '0 0 0 -23px', padding: 0, fontFamily: '"Google Sans", Arial, sans-serif' }} data-id><div id="goog-gt-vt" className="VIpgJd-yAWNEb-hvhgNd"><div className=" VIpgJd-yAWNEb-hvhgNd-l4eHX-i3jM8c"><img src="https://fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg" width={24} height={24} alt="" /></div><div className=" VIpgJd-yAWNEb-hvhgNd-k77Iif-i3jM8c"><div className="VIpgJd-yAWNEb-hvhgNd-IuizWc" dir="ltr">Original text</div><div id="goog-gt-original-text" className="VIpgJd-yAWNEb-nVMfcd-fmcmS VIpgJd-yAWNEb-hvhgNd-axAV1" /></div><div className="VIpgJd-yAWNEb-hvhgNd-N7Eqid ltr"><div className="VIpgJd-yAWNEb-hvhgNd-N7Eqid-B7I4Od ltr" dir="ltr"><div className="VIpgJd-yAWNEb-hvhgNd-UTujCb">Rate this translation</div><div className="VIpgJd-yAWNEb-hvhgNd-eO9mKe">Your feedback will be used to help improve Google Translate</div></div><div className="VIpgJd-yAWNEb-hvhgNd-xgov5 ltr"><button id="goog-gt-thumbUpButton" type="button" className="VIpgJd-yAWNEb-hvhgNd-bgm6sf" title="Good translation" aria-label="Good translation" aria-pressed="false"><span id="goog-gt-thumbUpIcon"><svg width={24} height={24} viewBox="0 0 24 24" focusable="false" className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"><path d="M21 7h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 0S7.08 6.85 7 7H2v13h16c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73V9c0-1.1-.9-2-2-2zM7 18H4V9h3v9zm14-7l-3 7H9V8l4.34-4.34L12 9h9v2z" /></svg></span><span id="goog-gt-thumbUpIconFilled"><svg width={24} height={24} viewBox="0 0 24 24" focusable="false" className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"><path d="M21 7h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 0S7.08 6.85 7 7v13h11c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73V9c0-1.1-.9-2-2-2zM5 7H1v13h4V7z" /></svg></span></button><button id="goog-gt-thumbDownButton" type="button" className="VIpgJd-yAWNEb-hvhgNd-bgm6sf" title="Poor translation" aria-label="Poor translation" aria-pressed="false"><span id="goog-gt-thumbDownIcon"><svg width={24} height={24} viewBox="0 0 24 24" focusable="false" className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"><path d="M3 17h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 24s7.09-6.85 7.17-7h5V4H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2zM17 6h3v9h-3V6zM3 13l3-7h9v10l-4.34 4.34L12 15H3v-2z" /></svg></span><span id="goog-gt-thumbDownIconFilled"><svg width={24} height={24} viewBox="0 0 24 24" focusable="false" className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"><path d="M3 17h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 24s7.09-6.85 7.17-7V4H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2zm16 0h4V4h-4v13z" /></svg></span></button></div></div><div id="goog-gt-votingHiddenPane" className="VIpgJd-yAWNEb-hvhgNd-aXYTce"><form id="goog-gt-votingForm" action="//translate.googleapis.com/translate_voting?client=te" method="post" target="votingFrame" className="VIpgJd-yAWNEb-hvhgNd-aXYTce"><input type="text" name="sl" id="goog-gt-votingInputSrcLang" /><input type="text" name="tl" id="goog-gt-votingInputTrgLang" /><input type="text" name="query" id="goog-gt-votingInputSrcText" /><input type="text" name="gtrans" id="goog-gt-votingInputTrgText" /><input type="text" name="vote" id="goog-gt-votingInputVote" /></form><iframe name="votingFrame" frameBorder={0} /></div></div></div><div id="wrapper" className>
        <div className="overlay" style={{ display: 'none' }} />
        {/* Sidebar */}
        <Nav />
        <div id="page-content-wrapper bg-white">
          <button type="button" className="hamburger animated fadeInLeft is-closed" data-toggle="offcanvas">
            <span className="hamb-top" />
            <span className="hamb-middle" />
            <span className="hamb-bottom" />
          </button>
          <div className="d-flex justify-content-between">
            <div className>
            </div>
            <div className=" me-2 mt-3">
              <p>Translate</p>
              <div id="google_translate_element" />
            </div>
          </div>
          <div className="container mt-3 bg-white mb-3">
            <div className="row">
              <div className="col-sm-12">
                <div className="features p-3">
                  <div className>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <h5>Plan:</h5>
                      <h5 className="text-capitalize">{Selectedinvestment.name}</h5>
                    </div>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <h5>Investment:</h5>
                      <h5>
                        $  {Selectedinvestment.minimum} - $  {Selectedinvestment.Maximum}
                      </h5>
                    </div>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <h5>Daily Profit:</h5>
                      <h5>  {Selectedinvestment.profits}%</h5>
                    </div>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <h5>Referral Bonus:</h5>
                      <h5>5%</h5>
                    </div>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <h5>Duration</h5>
                      <h5>
                      {Selectedinvestment.duration}
                        days
                      </h5>
                    </div>
                    <p className="text-center text-danger" id="warning">The least investment is $100</p>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <h2>Enter Amount</h2>
                      <div className="input-group w-50 mb-3">
                        <span className="input-group-text">$</span>
                        <input type="text" name="amount" className="form-control" aria-label="Amount (to the nearest dollar)" onChange={(e)=>{setAmount(e.target.value)}} />
                        <span className="input-group-text">.00</span>
                      </div>
                    </div>
                    <div className="container mt-3 mb-3">
                      <div className="row w-100">
                        <h3 className="text-center text-capitalize">Choose Payment Method</h3>
                        <div className="col-md-4 col-sm-12 col-lg-4 mt-3 mb-3" onClick={()=>{SetCoinInfo("1")}}>
                          <div className="position-relative start-0 top-0">
                            <div className="card pricing-box">
                              <div className="card-body p-3">
                                <a href onclick="cryptocurrency(event, $(this));" data-cypto="bitcoin" className="position-absolute start-0 top-0 w-100 h-100" />
                                <div className="d-flex align-items-center justify-content-around">
                                  <img src="https://img.icons8.com/?size=1x&id=ovHld7NfgG9g&format=gif" className="img-fluid" />
                                  <h4 className="text-uppercase">bitcoin</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 col-lg-4 mt-3 mb-3"onClick={()=>{SetCoinInfo("2")}}>
                          <div className="position-relative start-0 top-0">
                            <div className="card pricing-box">
                              <div className="card-body p-3">
                                <a href onclick="cryptocurrency(event, $(this));" data-cypto="ethereum" className="position-absolute start-0 top-0 w-100 h-100" />
                                <div className="d-flex align-items-center justify-content-around">
                                  <img src="https://img.icons8.com/?size=1x&id=N6QeGIFVpoZ3&format=png" className="img-fluid" />
                                  <h4 className="text-uppercase">ethereum</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 col-lg-4 mt-3 mb-3" onClick={()=>{SetCoinInfo("3")}}>
                          <div className="position-relative start-0 top-0">
                            <div className="card pricing-box">
                              <div className="card-body p-3">
                                <a href onclick="cryptocurrency(event, $(this));" data-cypto="usdt" className="position-absolute start-0 top-0 w-100 h-100" />
                                <div className="d-flex align-items-center justify-content-around">
                                  <img src="https://img.icons8.com/?size=1x&id=dCeLaRxYok4m&format=png" className="img-fluid" />
                                  <h4 className="text-uppercase">usdt</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wallet payment" style={{ display: 'block' }}>
                          <p className="text-center">Countdown</p>
                          <div className="text-center" id="countdown">02:43</div>
                          <div className="label">
                            <p className="text-center text-capitalize">Send to the wallet address</p>
                            <span className="text-capitalize" id="cryptocurrency">{CoinInfo.name} wallet address</span>
                            &nbsp; <span className="text-uppercase" id="network" />
                          </div>
                          <div className="copy-text">
                            <input type="text" id="address" className="text w-100" placeholder={CoinInfo.address} />
                            <button onClick={copyAlert}><i className="fa fa-clone" /></button>
                          </div>
                          <div className="text-center mt-3">
                            <button onClick={handleUpload} id="payment_made" className="btn bgcolor text-capitalize text-white">i have made payment</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Optional JavaScript; choose one of the two! */}
        {/* Option 1: Bootstrap Bundle with Popper */}
        {/* Option 2: Separate Popper and Bootstrap JS */}
        {/*
        
        
        */}
      </div><div className="VIpgJd-ZVi9od-aZ2wEe-wOHMyf"><div className="VIpgJd-ZVi9od-aZ2wEe-OiiCO"><svg xmlns="http://www.w3.org/2000/svg" className="VIpgJd-ZVi9od-aZ2wEe" width="96px" height="96px" viewBox="0 0 66 66"><circle className="VIpgJd-ZVi9od-aZ2wEe-Jt5cK" fill="none" strokeWidth={6} strokeLinecap="round" cx={33} cy={33} r={30} /></svg></div></div>
    </div>
  )
}

export default DepositComplete